import React, { FunctionComponent } from "react";

interface SummaryItemProps {
  name: string;
  value: React.ReactNode;
  isLink?: boolean;
}

const SummaryItem: FunctionComponent<SummaryItemProps> = ({
  name,
  value,
  isLink
}) => (
  <div className="dynamic_analysis__summary-data-item">
    <strong>{name}:</strong>
    {isLink && value != null ? (
      <a
        className="fireeye-url"
        href={value as string}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </a>
    ) : (
      <span>{value}</span>
    )}
  </div>
);

export default SummaryItem;
